// extracted by mini-css-extract-plugin
export default {"currency-indicator":"finance_currency-indicator_x"};